<template>
	<div class="">
		<Header></Header>
		<div class="dowlist w95">
			<ul>
				<!-- <li v-for="(item,index) in 6" :key='index'></li> -->
				<li>
					<div class="ysdow-bg">
						<img width="34px" height="45px" src="../assets/dow/pdf.png" alt="">
					</div>
					<div class="ysdowmain">
						<p>保教基础知识电子版教材.PDF</p>
						<p>12M</p>
					</div>
					<div class="ysdowicon">
						<img src="../assets/dow/nrxt.png" alt="">
					</div>
				</li>
				<li>
					<div class="ysdow-bg">
						<img width="34px" height="45px" src="../assets/dow/wl.png" alt="">
					</div>
					<div class="ysdowmain">
						<p>保教基础知识电子版教材.PDF</p>
						<p>12M</p>
					</div>
					<div class="ysdowicon">
						<img src="../assets/dow/nrxt.png" alt="">
					</div>
				</li>
				<li>
					<div class="ysdow-bg">
						<img width="34px" height="45px" src="../assets/dow/xl.png" alt="">
					</div>
					<div class="ysdowmain">
						<p>保教基础知识电子版教材.PDF</p>
						<p>12M</p>
					</div>
					<div class="ysdowicon">
						<img src="../assets/dow/nrxt.png" alt="">
					</div>
				</li>
				<li>
					<div class="ysdow-bg">
						<img width="34px" height="45px" src="../assets/dow/pdf.png" alt="">
					</div>
					<div class="ysdowmain">
						<p>保教基础知识电子版教材.PDF</p>
						<p>12M</p>
					</div>
					<div class="ysdowicon">
						<img src="../assets/dow/nrxt.png" alt="">
					</div>
				</li>
				<li>
					<div class="ysdow-bg">
						<img width="34px" height="45px" src="../assets/dow/wl.png" alt="">
					</div>
					<div class="ysdowmain">
						<p>保教基础知识电子版教材.PDF</p>
						<p>12M</p>
					</div>
					<div class="ysdowicon">
						<img src="../assets/dow/nrxt.png" alt="">
					</div>
				</li>
				<li>
					<div class="ysdow-bg">
						<img width="34px" height="45px" src="../assets/dow/xl.png" alt="">
					</div>
					<div class="ysdowmain">
						<p>保教基础知识电子版教材.PDF</p>
						<p>12M</p>
					</div>
					<div class="ysdowicon">
						<img src="../assets/dow/nrxt.png" alt="">
					</div>
				</li>
			</ul>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Dowmore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {

			}

		},
		methods: {

		}
	}
</script>

<style scoped>
	.dowlist {
		margin: 20px auto;
	}

	.dowlist ul li {
		height: 75px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
		border-radius: 20px;
		margin-top: 20px;
		display: flex;
	}

	.dowlist ul li .ysdow-bg {
		width: 34px;
		height: 45px;
		margin: 15px 10px;
	}

	.ysdowmain {
		flex: 1;

	}

	.ysdowmain p:nth-child(1) {
		font-size: 15px;
		font-weight: 600;
		height: 18px;
		overflow: hidden;
		line-height: 15px;
		color: #333;
		margin: 15px 10px;
	}

	.ysdowmain p:nth-child(2) {
		font-size: 13px;
		font-weight: 300;
		line-height: 15px;
		color: #999;
		margin: 0px 10px;

	}

	.ysdowicon {
		width: 30px;
		height: 100%;

	}

	.ysdowicon img {
		margin-top: 29px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dowmore.vue